import notFoundPage from "@/views/sharedPages/404.vue";
import errorPage from "@/views/sharedPages/Error.vue";

export default [
  {
    path: "/error",
    name: "errorPage",
    component: errorPage,
    layout: "LayoutError"
  },
  {
    path: "/*",
    name: "globalNotFound",
    component: notFoundPage,
    layout: "LayoutLogged"
  }
];
